import { FaChartArea, FaExclamationCircle, FaTools } from "react-icons/fa";
import {
  RiBarChart2Line,
  RiBookletLine,
  RiBox1Line,
  RiEditBoxLine,
  RiErrorWarningLine,
  RiFolderImageLine,
  RiFolderSettingsLine,
  RiHomeGearLine,
  RiHomeOfficeLine,
  RiLayout2Line,
  RiMacbookLine,
  RiMapPin3Line,
  RiMegaphoneLine,
  RiPagesLine,
  RiPhoneLine,
  RiSettings4Line,
  RiShapesLine,
  RiShoppingCartLine,
  RiToolsLine,
  RiTreeLine,
  RiUserLocationLine,
  RiUserSettingsLine,
} from "react-icons/ri";

const menu = [
  {
    key: "1",
    name: "Dashboard",
    icon: <RiLayout2Line />,
    link: "/admin/dashboard/commerce",
    help: "/admin/dashboard-help",
  },
  {
    key: "3",
    name: "CRM",
    icon: <RiPhoneLine />,
    menu: [],
  },
  {
    key: "4",
    name: "Products",
    icon: <RiMacbookLine />,
    menu: [
      {
        key: "4.1",
        name: "Main",
        icon: <RiBox1Line />,
        link: "/admin/product-manage/main",
      },
      {
        key: "4.2",
        name: "Bundle",
        icon: <RiBox1Line />,
        link: "/admin/product-manage/bundle",
      },
    ],
  },
  {
    key: "8",
    name: "Offer Manage",
    icon: <RiMegaphoneLine />,
    menu: [
      {
        key: "8.3",
        name: "Campaign",
        icon: <RiMegaphoneLine />,
        link: "/admin/scheme-manage/data-campaign",
      },
      {
        key: "8.1",
        name: "Pre-Order(Dealer)",
        icon: <RiMegaphoneLine />,
        link: "/admin/scheme-manage/pre-order",
      },
      {
        key: "8.2",
        name: "Scheme",
        icon: <RiMegaphoneLine />,
        link: "/admin/scheme-manage/campaign",
      },
      {
        key: "8.5",
        name: "Multi Buy",
        icon: <RiMegaphoneLine />,
        link: "/admin/scheme-manage/multi-buy",
      },
      {
        key: "8.5",
        name: "Pre-Order(Public)",
        icon: <RiMegaphoneLine />,
        link: "/admin/scheme-manage/public-pre-order",
      },
      {
        key: "8.4",
        name: "Field Name",
        icon: <RiMegaphoneLine />,
        link: "/admin/scheme-manage/main-field",
      },
    ],
  },
  {
    key: "10",
    name: "Orders",
    icon: <RiShoppingCartLine />,
    menu: [
      {
        key: "10.4",
        name: "Handraiser Manage",
        icon: <RiShoppingCartLine />,
        link: "/admin/handraiser-manage",
      },
      {
        key: "10.1",
        name: "Pre-Order",
        icon: <RiShoppingCartLine />,
        link: "/admin/order-manage/pre-order",
      },
      {
        key: "10.2",
        name: "Scheme",
        icon: <RiShoppingCartLine />,
        link: "/admin/order-manage/campaign",
      },

      {
        key: "10.3",
        name: "Multi Buy",
        icon: <RiShoppingCartLine />,
        link: "/admin/order-manage/multi-buy",
      },

      {
        key: "10.3",
        name: "Pre-Order(Public)",
        icon: <RiShoppingCartLine />,
        link: "/admin/order-manage/public-pre-order",
      },
    ],
  },
  {
    key: "6",
    name: "Home Page",
    icon: <RiShapesLine />,
    link: "/admin/home-page-groups",
  },
  {
    key: "5",
    name: "Content Sections",
    icon: <RiHomeGearLine />,
    menu: [
      {
        key: "5.1",
        name: "Product Section",
        icon: <RiHomeGearLine />,
        link: "/admin/product-section",
      },
      {
        key: "5.4",
        name: "Content Section",
        link: "/admin/content-manage",
        icon: <RiHomeGearLine />,
      },
      // {
      //   key: "5.5",
      //   name: "Menu Section",
      //   link: "/admin/menu-manage",
      //   icon: <RiHomeGearLine />,
      // },
      {
        key: "5.6",
        name: "Slider Section",
        icon: <RiHomeGearLine />,
        link: "/admin/slider-manage",
      },
    ],
  },
  {
    key: "7",
    name: "Content",
    icon: <RiEditBoxLine />,
    menu: [
      {
        key: "7.1",
        name: "Page",
        icon: <RiPagesLine />,
        link: "/admin/page-manage",
      },
      {
        key: "7.2",
        name: "Media",
        icon: <RiFolderImageLine />,
        link: "/admin/media-manage",
      },
    ],
  },
  {
    key: "9",
    name: "Setting",
    icon: <RiFolderSettingsLine />,
    menu: [
      {
        key: "9.3",
        name: "Tree View",
        icon: <RiTreeLine />,
        link: "/admin/location-tree-view",
      },
      {
        key: "9.1",
        name: "Locations",
        icon: <RiUserLocationLine />,
        menu: [
          {
            key: "9.1.2",
            name: "State",
            icon: <RiMapPin3Line />,
            link: "/admin/state-manage",
          },
          {
            key: "9.1.3",
            name: "District",
            icon: <RiMapPin3Line />,
            link: "/admin/district-manage",
          },
          // for this project area has beed swapped with vdc
          {
            key: "9.1.4",
            name: "Area",
            icon: <RiMapPin3Line />,
            link: "/admin/area-manage",
          },
        ],
      },

      {
        key: "9.4",
        name: "Global Settings",
        icon: <RiToolsLine />,
        link: "/admin/global-setting",
      },
    ],
  },
  {
    key: "11",
    name: "Reports",
    icon: <RiBarChart2Line />,
    menu: [
      {
        key: "11.1",
        name: "Pre-Order",
        icon: <RiBarChart2Line />,
        link: `/admin/order-report/pre-order`,
      },
      {
        key: "11.2",
        name: "Scheme",
        icon: <RiBarChart2Line />,
        link: `/admin/order-report/campaign`,
      },
      {
        key: "11.3",
        name: "Multi-Buy",
        icon: <RiBarChart2Line />,
        link: `/admin/order-report/multi-buy`,
      },
      {
        key: "11.4",
        name: "Pre-Order(Public)",
        icon: <RiBarChart2Line />,
        link: `/admin/order-report/public-pre-order`,
      },
      {
        key: "11.5",
        name: "Handraiser",
        icon: <RiBarChart2Line />,
        link: `/admin/handraiser-report`,
      },
      // {
      //   key: "11.3",
      //   name: "Stock Status",
      //   icon: <RiBarChart2Line />,
      //   link: "/admin/features-coming",
      //   ind_text: "Soon",
      //   ind_type: "info",
      //   // link: "/admin/stock-status",
      // },
      // {
      //   key: "11.4",
      //   name: "Category Report",
      //   icon: <RiBarChart2Line />,
      //   link: "/admin/features-coming",
      //   ind_text: "Soon",
      //   ind_type: "info",
      //   // link: "/admin/category-report",
      // },
      // {
      //   key: "11.5",
      //   name: "PG Report",
      //   icon: <RiBarChart2Line />,
      //   // ind_text: "Soon",
      //   // ind_type: "info",
      //   link: "/admin/pg-report",
      // },
    ],
  },

  {
    key: "17",
    name: "Office",
    icon: <RiHomeOfficeLine />,
    menu: [
      {
        key: "17.1",
        name: "Admin",
        icon: <RiHomeOfficeLine />,
        link: "/admin/office-manage/admin",
      },
      {
        key: "17.2",
        name: "National Distributor",
        icon: <RiHomeOfficeLine />,
        link: "/admin/office-manage/nd",
      },
      {
        key: "17.3",
        name: "Regional Distributor",
        icon: <RiHomeOfficeLine />,
        link: "/admin/office-manage/rd",
      },
      {
        key: "17.4",
        name: "Retailer",
        icon: <RiHomeOfficeLine />,
        link: "/admin/office-manage/retailer",
      },
      {
        key: "17.5",
        name: "Users",
        icon: <RiUserSettingsLine />,
        link: "/admin/user-manage",
      },
      {
        key: "17.6",
        name: "Roles",
        icon: <RiUserSettingsLine />,
        link: "/admin/role-manage",
      },
      {
        key: "17.7",
        name: "Contacts",
        icon: <RiBookletLine />,
        link: "/admin/contact-manage",
      },
    ],
  },
  {
    key: "18",
    name: "Modules",
    icon: <RiSettings4Line />,
    menu: [
      {
        key: "18.3",
        name: "Modules",
        icon: <RiSettings4Line />,
        link: "/admin/module-manage",
      },
      {
        key: "18.4",
        name: "Module Group",
        icon: <RiSettings4Line />,
        link: "/admin/sub-modules",
      },
    ],
  },

  {
    key: "19",
    name: "Error Logs",
    icon: <RiErrorWarningLine />,
    menu: [
      {
        key: "19.1",
        name: "Server Errors",
        icon: <RiErrorWarningLine />,
        link: "/admin/server-errors",
      },
      {
        key: "19.2",
        name: "Client Errors",
        icon: <RiErrorWarningLine />,
        link: "/admin/client-errors",
      },
    ],
  },
];
export default menu;
